import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import FormLabel from "controls/formLabel";
import TurnoutCheckoutsViewModel from "../../../viewModels/finance/turnoverCheckouts/turnoverCheckoutsViewModel";
import { observer } from "mobx-react-lite";
import { registerView } from "@frui.ts/views/dist";
import Form from "react-bootstrap/Form";
import AdvancedSelect from "@edaz/edazkit/controls/AdvancedSelect";
import Button from "@edaz/edazkit/Button/index";
import { IconType } from "@edaz/edazkit/Icon";

const TurnoutCheckoutsView: ViewComponent<TurnoutCheckoutsViewModel> = observer(({ vm }) => (
  <>
    <h3>{vm.name}</h3>
    <Form.Row className="bg-light rounded one-row-form">
      <Form.Group className="select">
        <FormLabel required={true}>{vm.translate("select")}</FormLabel>
        <AdvancedSelect
          target={vm}
          property="selectedDate"
          disabled={vm.busyWatcher.isBusy}
          items={vm.months}
          placeholder={vm.translate("select")}
        />
      </Form.Group>
      <Button
        className="rounded d-block"
        size="sm"
        disabled={vm.downloadDisabled}
        onClick={vm.onDownloadClick}
        iconLeft={vm.busyWatcher.isBusy ? IconType.Spinner : IconType.Download}>
        {vm.translate("download")}
      </Button>
    </Form.Row>
  </>
));

registerView(TurnoutCheckoutsView, TurnoutCheckoutsViewModel);
